export type PlaqueVariant = 'chalk' | 'clay' | 'sandstone' | 'limewash' | 'honey' | 'mineral-grey';

interface Props {
  size?: 'sm' | 'md';
  variant?: PlaqueVariant;
  className?: string;
}

// Material-sample plaque carrying the existing MATERA wordmark.
// One structure; the variant swaps only the sampled surface tone (see .plaque--* in index.css).
export default function MaterialPlaque({ size = 'md', variant = 'chalk', className = '' }: Props) {
  const dims = size === 'sm' ? 'w-[148px] h-[56px] text-base' : 'w-[200px] h-[76px] text-xl';
  return (
    <div className={`material-plaque plaque--${variant} ${dims} ${className}`} role="img" aria-label="MATERA">
      <span className="material-plaque__mark font-heading font-bold tracking-[-0.04em]">MATERA</span>
    </div>
  );
}